jQuery(document).ready(function () {

  if ($('.simpleheader').length > 0) {
    var $trigger = $('.simpleheader_modaltrigger');
    var $close = $('.modal-close');
    var $modal = $('.modal-box');

    $(".modal-box_candidature").click(function () {
      $modal.removeClass("modal-box-active");
      $(".spontaneous_form_container").toggle();
    });

    $(".simpleheader_item").hover(
      function () {
        $(".simpleheader_children").stop(true, true).slideUp(200); // Ferme tous les autres
        $(this).find(".simpleheader_children").stop(true, true).slideDown(200); // Ouvre celui concerné
      },
      function () {
        $(this).find(".simpleheader_children").stop(true, true).slideUp(200); // Option : refermer au hover out
      }
    );

    $(".modal-box_mobilehaschild").click(function () {
      $(this).next(".modal-box_mobilechildren").slideToggle();
      $(this).prev(".modal-box_arrow").toggleClass("modal-box_arrow-active");
    });

    $trigger.click(function () {
      $modal.addClass("modal-box-active");
      $("body").css("overflow", "hidden");
    });

    $close.click(function () {
      $modal.removeClass("modal-box-active");
      $("body").css("overflow", "auto");
    });
  }

});
